export default __webpack_public_path__ + "static/media/shop-tab-icon.31fb57b6.svg";